'use strict'
// Template version: 1.3.1
// see http://vuejs-templates.github.io/webpack for documentation.

const path = require('path')
// 前端开发环境 HOST 和 PORT
var FRONT_DEV_HOST = '0.0.0.0'
var FRONT_DEV_PORT = 8077

// 后端开发环境 HOST 和 PORT
var SERVER_DEV_HOST = '127.0.0.1'
// var SERVER_DEV_HOST = "47.100.244.39";
// var SERVER_DEV_PORT = 8098;
var SERVER_DEV_PORT = 8000

// 图片服务器
var SERVER_IMG_HOST = '47.100.244.39'
// var SERVER_DEV_HOST = "118.195.232.253";
var SERVER_IMG_PORT = 8081
// http://47.100.244.39:8081

module.exports = {
  hostConfig: {
    frontHost: `http://${FRONT_DEV_HOST}:${FRONT_DEV_PORT}/`,
    serverHost: `http://${SERVER_DEV_HOST}:${SERVER_DEV_PORT}/`,
    imgHost: `http://${SERVER_IMG_HOST}:${SERVER_IMG_PORT}`
  },
  dev: {

    // Paths
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',
    proxyTable: {
      '/server_api': {
        target: `http://${SERVER_DEV_HOST}:${SERVER_DEV_PORT}/`,
        changeOrigin: true,
        pathRewrite: {
          '^/server_api': ''
        },
        secure: false
      }
    },

    // Various Dev Server settings
    host: FRONT_DEV_HOST, // can be overwritten by process.env.HOST
    port: FRONT_DEV_PORT, // can be overwritten by process.env.PORT, if port is in use, a free one will be determined
    autoOpenBrowser: false,
    errorOverlay: true,
    notifyOnErrors: true,
    poll: false, // https://webpack.js.org/configuration/dev-server/#devserver-watchoptions-

    // Use Eslint Loader?
    // If true, your code will be linted during bundling and
    // linting errors and warnings will be shown in the console.
    useEslint: true,
    // If true, eslint errors and warnings will also be shown in the error overlay
    // in the browser.
    showEslintErrorsInOverlay: false,

    /**
     * Source Maps
     */

    // https://webpack.js.org/configuration/devtool/#development
    devtool: 'cheap-module-eval-source-map',

    // If you have problems debugging vue-files in devtools,
    // set this to false - it *may* help
    // https://vue-loader.vuejs.org/en/options.html#cachebusting
    cacheBusting: true,

    cssSourceMap: true
  },

  build: {
    // Template for index.html
    index: path.resolve(__dirname, '../dist/index.html'),

    // Paths
    assetsRoot: path.resolve(__dirname, '../dist'),
    assetsSubDirectory: 'static',
    assetsPublicPath: '/',

    /**
     * Source Maps
     */

    productionSourceMap: true,
    // https://webpack.js.org/configuration/devtool/#production
    devtool: '#source-map',

    // Gzip off by default as many popular static hosts such as
    // Surge or Netlify already gzip all static assets for you.
    // Before setting to `true`, make sure to:
    // npm install --save-dev compression-webpack-plugin
    productionGzip: false,
    productionGzipExtensions: ['js', 'css'],

    // Run the build command with an extra argument to
    // View the bundle analyzer report after build finishes:
    // `npm run build --report`
    // Set to `true` or `false` to always turn it on or off
    bundleAnalyzerReport: process.env.npm_config_report
  }
}



//////////////////
// WEBPACK FOOTER
// ./config/index.js
// module id = FhoZ
// module chunks = 6